// 🧭 شريط تنقّل حساب الشريك (ارت تاتش) - نفس الروابط اللي يبنيها Navbar.js
// بالضبط (تنمرّر كـpages)، بشكل بسيط بهوية Artika.
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { P } from "./partnerTheme";
import "../styles/artika-fonts.css";

export const ArtikaMark = ({ size = 28, color = P.ink, bg = "#fff" }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" aria-hidden>
    <rect width="100" height="100" fill={color} />
    <rect x="0" y="19" width="81" height="81" fill={bg} />
    <rect x="0" y="29" width="71" height="71" fill={color} />
    <rect x="16" y="45" width="40" height="40" fill={bg} />
  </svg>
);

// روابط صفحات ارت تاتش - تُستخدم بشريط الشريك وبشريط المدير داخل واجهة ارت تاتش
export const PartnerTabs = ({ pages }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  // /partner-add نفس صفحة إضافة طلب (بيع مباشر)
  const isActive = (path) => pathname === path || (path === "/partner-order" && pathname === "/partner-add");

  return (
    <>
      {pages.map((page) => {
        const active = isActive(page.path);
        return (
          <button
            key={page.path}
            onClick={() => navigate(page.path)}
            className="px-4 h-10 rounded-lg text-[15px] font-bold whitespace-nowrap transition-colors"
            style={active ? { background: P.ink, color: "#fff" } : { color: P.ink2 }}
          >
            {page.label}
          </button>
        );
      })}
    </>
  );
};

const PartnerNavbar = ({ pages, onLogout }) => {
  const links = <PartnerTabs pages={pages} />;

  return (
    <nav
      dir="rtl"
      className="sticky top-0 z-50 w-full"
      style={{ fontFamily: P.font, background: "#fff", borderBottom: `1px solid ${P.line}` }}
    >
      <div className="max-w-[1180px] mx-auto px-4 h-[64px] flex items-center justify-between gap-4">
        <div className="flex items-center gap-2.5">
          <ArtikaMark size={28} />
          <span style={{ fontWeight: 800, fontSize: 20, color: P.ink, direction: "ltr", letterSpacing: "-0.02em" }}>Artika</span>
        </div>

        <div className="hidden md:flex items-center gap-1">{links}</div>

        <button
          onClick={onLogout}
          className="flex items-center gap-2 h-10 px-3 rounded-lg text-[14px] font-bold"
          style={{ color: P.danger, border: `1px solid ${P.line}` }}
          aria-label="تسجيل الخروج"
        >
          <LogOut size={17} />
          تسجيل الخروج
        </button>
      </div>

      {/* الموبايل: الروابط بسطر تحت الشعار */}
      <div className="md:hidden flex gap-1 px-3 pb-2 overflow-x-auto">{links}</div>
    </nav>
  );
};

export default PartnerNavbar;
